/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { KomboGetJobsPathParams, KomboGetJobsQueryParams, KomboGetJobsResponse } from '../types/KomboGetJobs'

/**
 * GET /export-integrations/integrations/:id/jobs
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/KomboController.php KomboController::getJobs
 */
export async function komboGetJobs(
	id: KomboGetJobsPathParams['id'],
	params?: KomboGetJobsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<KomboGetJobsResponse>> {
	return axiosInstance.get(`/export-integrations/integrations/${id}/jobs`, { params, ...config })
}
